<template>
         <!-- 下拉菜单 -->
         <transition name="dropdown">
            <div v-show="showDialog" class="dropdown-content" @mouseleave="hideDropDown">
                <ul class="navgo" @click="hideDropDown">
                  
                  <router-link to="/">
                    <li>首页</li>
                  </router-link>
                  <router-link v-for="item,index in tagNav" :key="index" :to="item.etitle">
                    <li>{{ item.title }}</li>
                  </router-link>
                  
                  <!-- <router-link to="/classify">
                    <li>产品分类</li>
                  </router-link>
                  <router-link to="/display">
                    <li>案例展示</li>
                  </router-link>
                  <router-link to="/news">
                    <li>新闻动态</li>
                  </router-link>
                  <router-link to="/serveview">
                    <li>服务流程</li>
                  </router-link>
                  <router-link to="/myview">
                    <li>联系我们</li>
                  </router-link> -->

                  
                </ul>

            </div>
        </transition>
</template>
<script>
import {mapState} from 'vuex'
export default {
    name: 'diaLog',
    props: {
        isShow:{
            type:Boolean
        },
    },
    data(){
        return{
          input:'',
          activeIndex: '1',
        }
    },
    computed:{
      ...mapState([ 'tagNav']),
        showDialog:{
            get(){
                return this.isShow
            },
            set(val){
                this.$emit('updateVisible',val)
            }
        }
    },
    mounted(){},
    methods:{
        hideDropDown() {
            // e.pageY：鼠标指针相对页面的偏移量
            console.log('鼠标指针相对页面的偏移量');
            this.$emit('updateVisible',false)
            // if (this.isShow && e.clientY >= this.navTop)  this.$emit('updateVisible',false)

        },
        handleClose(done) {
        done();
        // this.$confirm('确认关闭？')
        //   .then(_ => {
        //     done();
        //   })
        //   .catch(_ => {});
      },
      handleSelect(e){
          if (e == '/') {
            // this.color = '#016F62'
            // this.textcolor= '#ffffff'
            // this.activetextcolor = '#333333'
          }else{
            // this.color = '#ffffff'
            // this.textcolor= '#000000'
            // this.activetextcolor = '#ffffff'
          }
          

      }
    }
}
</script>
<style lang="less" scoped>
// 下拉菜单收缩展开
@keyframes expand-contract {
  0% {
    opacity: 0;
    height: 0;
    // max-height: 0;
  }
  100% {
    opacity: 1;
    height: 200px;
    //max-height: 300px;  // 大于等于下拉菜单的高度
  }
}
.dropdown-enter-active {
  animation: expand-contract 0.9s;
}
.dropdown-leave-active {
  animation: expand-contract 0.9s reverse;
}
// 内容变化
@keyframes dropdown-menu {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.dropdown-content {
  position: absolute;
  top: 240px;
  left: 0;
  width: 100%; // 拉满
  overflow: hidden;
  z-index: 10;
  
}
// ==============================
.navgo{
  background-color: #fff;
  padding-bottom: 30px;
  li{
    font-size: 26px;
    color: #333333;
    margin-bottom: 60px;
   
  }

  a{
    text-decoration: none;
  }
  .router-link{
    text-decoration: none;
  }
}
</style>